import {useForm, useForm as useFormInertia} from "@inertiajs/inertia-react";
import i18n from "i18next";
import {useState} from "react";
import PasswordValidationService from "@/Utilities/PasswordValidationService";
import {ApplicationViewType} from "@/Enums/ApplicationViewType";

export default function usePasswordStateManager(applicationViewType, extraFormValues = {}) {
    const {data, setData, post, processing, errors} = initialisePasswordForm();
    const [validationState, setValidationState] = initialiseValidationState();
    const [passwordMatchValidationRuleActive, setPasswordMatchValidationRuleActive] = useState(false);

    function initialisePasswordForm() {
        if(applicationViewType === ApplicationViewType.AUTH) {
            return useFormInertia(
                {
                    ...extraFormValues,
                    password: '',
                    password_confirmation: ''
                }
            );
        } else {
            return useForm({
                password: '',
                password_confirmation: ''
            });
        }
    }

    function initialiseValidationState() {

        return useState({
            validationItems: [
                {name: i18n.t("set-password.8-characters"), valid: null},
                {name: i18n.t("set-password.1-number"), valid: null},
                {name: i18n.t("set-password.1-uppercase"), valid: null},
                {name: i18n.t("set-password.1-special"), valid: null},
                {name: i18n.t("set-password.1-lowercase"), valid: null},
                {name: i18n.t("set-password.passwords-match"), valid: null}
            ],
            passwordIsValid: false
        });
    }

    function onChange(name, value) {
        let newState = {...validationState};

        if (name === "password") {
            newState.validationItems[0].valid = PasswordValidationService.checkIsValidLength(value);
            newState.validationItems[1].valid = PasswordValidationService.checkContainsNumber(value);
            newState.validationItems[2].valid = PasswordValidationService.checkUppercase(value);
            newState.validationItems[3].valid = PasswordValidationService.checkHasSpecialChar(value);
            newState.validationItems[4].valid = PasswordValidationService.checkLowercase(value);
        }

        if(name === 'password_confirmation' && passwordMatchValidationRuleActive === false) {
            setPasswordMatchValidationRuleActive(true);
            newState.validationItems[5].valid = PasswordValidationService.checkIfPasswordsMatch(name, value, data);
        }

        //check on password_confirmation change
        if ((name === "password" || name === 'password_confirmation') && passwordMatchValidationRuleActive) {
            newState.validationItems[5].valid = PasswordValidationService.checkIfPasswordsMatch(name, value, data);
        }

        newState.passwordIsValid = !!Object.values(newState.validationItems).every(item => item.valid === true);

        setValidationState(newState);
        setData(name, value);
    }

    //for email and phone number field
    function onEmailPhoneTokenChange(name, value) {
        setData(name, value);
    }

    return {data, validationState, onChange, onEmailPhoneTokenChange, post, processing, errors}
}
